module.exports = (__webpack_require__(14))(0);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react/index.js from dll-reference vendor_library
// module id = 1
// module chunks = 0